import React, { useEffect, useMemo, useState } from 'react';
import styles from './Profile.module.scss';
import { Text, textVariantsEnum, fontWeightEnum } from '@/components/Text';
import { useSelector } from 'react-redux';
import { plans } from '@/config/constants';
import { Button, buttonVariants } from '@/components/Button';
import { Accordion } from '@/components/Accordion';
import { useHistory } from 'react-router-dom';
import { Modal } from '@/components/Modal';
import { CancelSubscriptionModal } from '../Subscription/CancelSubscriptionModal.component';
import httpClient from '../../config/httpClient';

import { addNotification, notificationStates } from '@/components/Notification';
import { SvgIcon, SvgIconSrc } from '@/components/SvgIcon';
import { ManageCardsModal } from '@/modals/ManagePaymentCards/ManageCardsModal.component';
import { Spinner } from 'reactstrap';
export const PlanBillingTab = () => {
  const subscription = useSelector(
    (state) => state.auth?.profile?.subscription
  );
  const [isCancelSubscriptionModalOpen, setIsCancelSubscriptionModalOpen] =
    useState(false);
  const [isManageCardsModalOpen, setIsManageCardsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [paymentDetailsLoading, setPaymentDetailsLoading] = useState(false);

  const currentPlan = plans[subscription?.planId];
  const getRazorpayPaymentDetails = async () => {
    const paymentId = subscription?.lastPayment?.paymentId;
    try {
      if (!paymentId) return;
      const response = await httpClient.post('/getRazorpayPaymentDetails', {
        paymentId,
      });
      if (response.data.success) {
        setPaymentDetails(response.data.data);
      }
    } catch (error) {
      console.log(error, '>>> PlanBillingTab.component.jsx <<<', 'line-42');
    } finally {
      setPaymentDetailsLoading(false);
    }
  };
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const getSubscriptionDetails = async () => {
    const response = await httpClient.post('/getSubscriptionDetails', {
      subscriptionId: subscription?.subscriptionId,
    });
    if (response.data.success) {
      setSubscriptionDetails(response.data.data);
    }
  };
  useEffect(() => {
    if (subscription?.lastPayment?.paymentId) {
      setPaymentDetailsLoading(true);
      getRazorpayPaymentDetails();
    }
    if (subscription?.subscriptionId) {
      getSubscriptionDetails();
    }
  }, [subscription]);

  const handleCancelPlan = async () => {
    try {
      setIsLoading(true);
      const response = await httpClient.post('/cancelSubscriptionPlan', {
        subscriptionId: subscription?.subscriptionId,
      });
      const result = response.data;
      if (result.success) {
        addNotification({
          message: 'Subscription cancelled successfully.',
          level: notificationStates.success,
          autoDismiss: 4,
        });
        history.push('/dashboard-overview');
        window.location.reload();
      }
    } catch (error) {
      console.log(error, '>>> index.jsx <<<', 'line-415');
    } finally {
      setIsLoading(false);
    }
  };
  const history = useHistory();
  const isSubscriptionActive = subscription?.status === 'active';
  const nextPaymentDate = useMemo(() => {
    if (subscription?.nextPaymentDate) {
      return new Date(
        subscription?.nextPaymentDate?.seconds * 1000
      ).toDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
      });
    }
    return null;
  }, [subscription?.nextPaymentDate]);
  const getPaymentDetails = () => {
    if (paymentDetailsLoading) {
      return <Spinner size={'sm'} />;
    }
    if (paymentDetails?.card?.last4) {
      return (
        <div className={styles.paymentDetailsCard}>
          <SvgIcon src={SvgIconSrc.creditCard} size={24} />
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="primary-500"
          >
            {'**** **** **** '}
            {paymentDetails?.card?.last4}
          </Text>
        </div>
      );
    }
    if (paymentDetails?.upi?.vpa) {
      return (
        <div className={styles.paymentDetailsCard}>
          <SvgIcon src={SvgIconSrc.upi} size={32} />
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="primary-500"
          >
            {paymentDetails?.upi?.vpa}
          </Text>
        </div>
      );
    }
    return null;
  };
  const getInActiveSubscriptionDetails = () => {
    if (subscription?.subscriptionEndDate?.toDate() > new Date()) {
      return (
        <div>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="primary-500"
          >
            Subscription was cancelled on
            <strong>
              {''}{' '}
              {subscription?.cancelledAt?.toDate().toLocaleDateString('en-US', {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
              })}
            </strong>
            .
          </Text>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="primary-500"
          >
            Your current subscription cycle ends on{' '}
            <strong>
              {''}{' '}
              {subscription?.subscriptionEndDate
                ?.toDate()
                .toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                })}
            </strong>
            .
          </Text>
          <Text
            variant={textVariantsEnum.Text_sm}
            fontWeight={fontWeightEnum.Normal}
            color="primary-500"
          >
            If you want to continue using the app, you can purchase a new
            subscription.
          </Text>
        </div>
      );
    }
    return (
      <Text
        variant={textVariantsEnum.Text_sm}
        fontWeight={fontWeightEnum.Normal}
        color="primary-500"
      >
        No active subscription.
      </Text>
    );
  };
  return (
    <>
      {' '}
      <Modal
        isVisible={isCancelSubscriptionModalOpen}
        onClose={() => setIsCancelSubscriptionModalOpen(false)}
      >
        <CancelSubscriptionModal
          onClose={() => setIsCancelSubscriptionModalOpen(false)}
          onConfirm={() => {
            handleCancelPlan();
            setIsCancelSubscriptionModalOpen(false);
          }}
        />
      </Modal>
      <Modal
        isVisible={isManageCardsModalOpen}
        onClose={() => setIsManageCardsModalOpen(false)}
      >
        <ManageCardsModal />
      </Modal>{' '}
      <div className={styles.planBillingTab}>
        <div className={styles.planBillingTitleContainer}>
          <Text
            variant={textVariantsEnum.Text_xl}
            fontWeight={fontWeightEnum.Bold}
            color="primary-500"
          >
            Plan & Billing
          </Text>
        </div>
        <div className={styles.planBillingDetailsContainer}>
          <div className={styles.planBillingDetailsContent}>
            <Text
              variant={textVariantsEnum.Text_lg}
              fontWeight={fontWeightEnum.Bold}
              color="primary-500"
            >
              Plan
            </Text>
            {isSubscriptionActive ? (
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                {currentPlan?.label}{' '}
                {`${currentPlan?.currencySymbol}${currentPlan?.price}/${currentPlan?.billingCycle}`}
              </Text>
            ) : (
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                No Active plan.
              </Text>
            )}
          </div>
          {isSubscriptionActive && (
            <div className={styles.planBillingDetailsContent}>
              <Text
                variant={textVariantsEnum.Text_lg}
                fontWeight={fontWeightEnum.Bold}
                color="primary-500"
              >
                Billed{' '}
                {currentPlan?.billingCycle.charAt(0).toUpperCase() +
                  currentPlan?.billingCycle.slice(1)}
                ly
              </Text>
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                Next Payment Date: {nextPaymentDate}
              </Text>
            </div>
          )}
        </div>

        <div className={styles.planBillingDetailsContainer}>
          <div className={styles.planBillingDetailsContent}>
            <Text
              variant={textVariantsEnum.Text_lg}
              fontWeight={fontWeightEnum.Bold}
              color="primary-500"
            >
              Billing Information
            </Text>
            {isSubscriptionActive ? (
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                {'email:'}&nbsp; {paymentDetails?.email}
              </Text>
            ) : (
              '-'
            )}
          </div>
        </div>

        <div className={styles.paymentDetailsContainer}>
          <div className={styles.paymentDetailsItemContainer}>
            <Text
              variant={textVariantsEnum.Text_xl}
              fontWeight={fontWeightEnum.Bold}
              color="primary-500"
            >
              Payment Details
            </Text>
            {isSubscriptionActive ? (
              getPaymentDetails()
            ) : (
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                No payment details found
              </Text>
            )}
          </div>
        </div>
        <div className={styles.subscriptionDetailsContainer}>
          <Accordion
            className={styles.subscriptionAccordion}
            heading={
              <div className={styles.subscriptionHeading}>
                <Text
                  variant={textVariantsEnum.Text_xl}
                  fontWeight={fontWeightEnum.Bold}
                  color="primary-500"
                >
                  Subscription
                </Text>
                <Text
                  variant={textVariantsEnum.Text_lg}
                  fontWeight={fontWeightEnum.Normal}
                  color="primary-500"
                >
                  Cancel a Subscription
                </Text>
              </div>
            }
          >
            <div className={styles.subscriptionDetailsContent}>
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                You can cancel your subscription at any time. You’ll keep access
                to premium features until your current billing period ends.
                Please note that this action can’t be undone.
              </Text>
            </div>
            <div className={styles.subscriptionDetailsContent}>
              <Text
                variant={textVariantsEnum.Text_sm}
                fontWeight={fontWeightEnum.Normal}
                color="primary-500"
              >
                Your active subscriptions:
              </Text>
              <div className={styles.subscriptionDetailsContentCard}>
                {isSubscriptionActive ? (
                  <div className={styles.subscriptionDetailsContentCardItem}>
                    <Text
                      variant={textVariantsEnum.Text_md}
                      fontWeight={fontWeightEnum.Normal}
                      color="primary-500"
                    >
                      {currentPlan?.label}{' '}
                      {`${currentPlan?.currencySymbol}${currentPlan?.price}/${currentPlan?.billingCycle}`}
                    </Text>
                    <Text
                      variant={textVariantsEnum.Text_sm}
                      fontWeight={fontWeightEnum.Normal}
                      color="primary-500"
                    >
                      Next Payment Date: {nextPaymentDate}
                    </Text>
                  </div>
                ) : (
                  getInActiveSubscriptionDetails()
                )}
                <div className={styles.subscriptionDetailsContentCardButtons}>
                  <Button
                    text={`${isSubscriptionActive ? 'Switch' : 'Purchase'} Subscription`}
                    onClick={() => {
                      history.push('/subscription');
                    }}
                    style={{
                      backgroundColor: '#3363F5',
                    }}
                  />
                  {isSubscriptionActive && (
                    <>
                      <Button
                        isLoading={isLoading}
                        text="Manage Subscription"
                        onClick={() => {
                          if (subscriptionDetails?.short_url) {
                            window.open(
                              subscriptionDetails?.short_url,
                              '_blank'
                            );
                          }
                        }}
                        style={{
                          backgroundColor: '#3363F5',
                        }}
                      />
                      <Button
                        isLoading={isLoading}
                        text="Cancel Subscription"
                        onClick={() => {
                          setIsCancelSubscriptionModalOpen(true);
                        }}
                        style={{
                          backgroundColor: '#3363F5',
                        }}
                      />
                    </>
                  )}
                </div>
              </div>
            </div>
          </Accordion>
        </div>
      </div>
    </>
  );
};
